(function () {
  'use strict';

  document.documentElement.classList.add('honeycomb-variant-images-loading');

  const loadingStyles = document.createElement('style');
  loadingStyles.textContent = `
    .honeycomb-variant-images-loading .media-gallery__grid > li {
      opacity: 0 !important;
    }

    .honeycomb-variant-images-ready .media-gallery__grid > li {
      transition: opacity 120ms ease;
    }
  `;
  document.head.appendChild(loadingStyles);

  const IMAGE_MAP = {
    Black: [
      'CatchtheBuzzShortsBlack',
      'CatchtheBuzzShorts-Black',
      'CTBShirtblack',
      'ArizonaOmbreLoganfront',
      'ArizonaOmbreloganback',
    ],
    Gray: ['ombregray1BackgroundRemoved', 'ombregray2BackgroundRemoved'],
    Green: [
      'CTBShorts',
      'IQVCYWXNQHDPLX2OEGZ64MVR',
      '63NH56EK3KKOJGWVXDBNX3ZT',
      '4YL5MDH5LU2U4BOEPWADM233',
    ],
  };

  let currentColor = null;
  let filterTimer = null;
  let observer = null;
  let isFiltering = false;

  function getFilename(src) {
    try {
      return src.split('?')[0].split('/').pop() || '';
    } catch {
      return '';
    }
  }

  function getColorFromAlt(alt) {
    if (!alt) return null;

    const matches = [...alt.matchAll(/#color[_-]([a-zA-Z0-9]+)/gi)];
    if (matches.length > 0) return matches.map((match) => match[1]);

    return alt.trim() === 'all-variants' ? ['all-variants'] : null;
  }

  function getColorFromFilename(filename) {
    const lowerFilename = filename.toLowerCase();

    for (const [color, fragments] of Object.entries(IMAGE_MAP)) {
      if (fragments.some((fragment) => lowerFilename.includes(fragment.toLowerCase()))) {
        return [color];
      }
    }

    return null;
  }

  function getImageColors(img) {
    const alt = img.getAttribute('alt') || '';
    const src =
      img.currentSrc ||
      img.getAttribute('src') ||
      img.getAttribute('data-src') ||
      img.getAttribute('srcset') ||
      img.getAttribute('data-srcset') ||
      '';

    return getColorFromAlt(alt) || getColorFromFilename(getFilename(src));
  }

  function getSelectedColor() {
    const gallery = document.querySelector('.media-gallery__grid');
    if (!gallery) return null;

    const galleryColors = new Set();
    gallery.querySelectorAll('img').forEach((img) => {
      const colors = getImageColors(img);
      if (!colors) return;

      colors.forEach((color) => {
        if (color !== 'all-variants') galleryColors.add(color.toLowerCase());
      });
    });

    const selectedOptions = [
      ...document.querySelectorAll('.variant-option input[type="radio"]:checked'),
      ...document.querySelectorAll('.variant-option select'),
    ];

    const selectedColor = selectedOptions.find((option) =>
      galleryColors.has(option.value.toLowerCase())
    );

    return selectedColor ? selectedColor.value : null;
  }

  function applyFilter(selectedColor) {
    if (!selectedColor || isFiltering) return;

    isFiltering = true;
    const gallery = document.querySelector('.media-gallery__grid');

    if (!gallery) {
      isFiltering = false;
      return;
    }

    let firstShown = null;

    gallery.querySelectorAll('li').forEach((item) => {
      const img = item.querySelector('img');
      if (!img) return;

      const imageColors = getImageColors(img);
      const show =
        imageColors === null ||
        imageColors.includes('all-variants') ||
        imageColors.some((color) => color.toLowerCase() === selectedColor.toLowerCase());

      item.style.setProperty('display', show ? '' : 'none', 'important');
      if (show && !firstShown) firstShown = item;
    });

    if (firstShown) {
      setTimeout(() => {
        firstShown.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'start' });
      }, 60);
    }

    isFiltering = false;
  }

  function refreshFilter() {
    currentColor = getSelectedColor();
    if (currentColor) applyFilter(currentColor);
    document.documentElement.classList.remove('honeycomb-variant-images-loading');
    document.documentElement.classList.add('honeycomb-variant-images-ready');
  }

  function scheduleFilter(delay) {
    clearTimeout(filterTimer);
    filterTimer = setTimeout(() => {
      refreshFilter();
    }, delay);
  }

  function init() {
    refreshFilter();

    document.addEventListener('change', (event) => {
      if (event.target.type !== 'radio' && event.target.tagName !== 'SELECT') return;

      document.documentElement.classList.add('honeycomb-variant-images-loading');
      scheduleFilter(50);
      setTimeout(refreshFilter, 250);
      setTimeout(refreshFilter, 600);
      setTimeout(refreshFilter, 1200);
    });

    observer = new MutationObserver((mutations) => {
      const pageChanged = mutations.some(
        (mutation) =>
          (mutation.type === 'childList' && mutation.addedNodes.length > 0) ||
          mutation.type === 'attributes'
      );

      if (pageChanged && !isFiltering) scheduleFilter(100);
    });

    observer.observe(document.body, {
      attributes: true,
      attributeFilter: ['src', 'srcset', 'checked', 'selected'],
      childList: true,
      subtree: true,
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();